import { render, staticRenderFns } from "./from.vue?vue&type=template&id=0a2e1550&"
import script from "./from.vue?vue&type=script&lang=js&"
export * from "./from.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports